// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32uK_","content":"styles_content__3IKSQ"};